import { Dayjs } from "dayjs";

export const formatDate = (dateString: string) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';
  // Guard against Go/MySQL zero-date sentinel (0001-01-01) that leaks through
  // when no date was provided in a CV and parseTime=true is set on the DB DSN.
  if (date.getFullYear() < 100) return '';
  return date.toISOString().split('T')[0].replace(/-/g, '.');
};

export const formatDateForApi = (date: Dayjs | null): string => {
  return date ? date.format('YYYY-MM-DD') : '';
};